import { gql } from "@apollo/client";

export const CUSTOM_SADDLE_ORDER_REQUEST = gql`
  mutation CreateCustomSaddleOrder($input: CreateCustomSaddleOrderRequestInput!) {
    createCustomSaddleOrderRequest(input: $input) {
      id
      horseName
      status
      saddleType
      saddleSpecs {
        seatSize
        discipline
        treeType
        riggingType
        seatMaterial
        fleece
        cantleHeight
        hornStyle
        skirtLength
        color
        toolingPreference
      }
      shippingDestination
      shippingAddress {
        street
        city
        state
        zipCode
        country
        phone
      }
      customerNotes
      createdAt
      updatedAt
    }
  }
`;


export const LIST_MY_CUSTOM_SADDLE_ORDERS = gql`
 query ListMyOrders($limit: Int, $nextToken: String) {
  listMyCustomSaddleOrders(limit: $limit, nextToken: $nextToken) {
    items {
      id
      orderId
      horseName
      status
      saddleType
      customOrderStatus {
        status
        timestamp
      }
      saddleSpecs {
        seatSize
        discipline
      }
      shippingDestination
      shippingAddress {
        street
        city
        state
        zipCode
        country
        phone
      }
      manufacturerName
      customerNotes
      createdAt
      updatedAt
    }
    nextToken
    count
  }
}
`;